import { useEffect, useCallback } from 'react';

/**
 * Custom hook to automatically scroll a container to the bottom when dependencies change.
 * @param messagesEndRef Ref to the element at the bottom of the scrollable container.
 * @param dependencies Array of dependencies that trigger the scroll effect.
 */
export function useAutoScroll(messagesEndRef: React.RefObject<HTMLDivElement>, dependencies: any[]) {
  const scrollToBottom = useCallback(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messagesEndRef]);

  useEffect(() => {
    scrollToBottom();
  }, [dependencies, scrollToBottom]); // Include dependencies and scrollToBottom
} 